<mat-drawer-container class="drawer-container" autosize>
  <mat-drawer #drawer mode="over" position="end" class="custom-drawer" [disableClose]="true">
    <div>
      <div class="title-menu-filter">
        <div class="flex">
          <mat-icon>style</mat-icon>
          &nbsp;
          <span *ngIf="drawerMode === 'product'"><b>Atributos de producto</b></span>
          <span *ngIf="drawerMode === 'client'"><b>Añadir/Editar atributo por cliente</b></span>

        </div>
        <div class="drawer-actions">
          <button mat-button (click)="closeDrawer()">CERRAR</button>

          <button *ngIf="drawerMode === 'product'" mat-flat-button color="primary" (click)="updateObject()">
            APLICAR CAMBIOS
          </button>

          <button *ngIf="drawerMode === 'client'" mat-flat-button color="primary" (click)="saveClientObject()">
            GUARDAR
          </button>
        </div>
      </div>

      <div class="form-attributes">

        <form *ngIf="drawerMode === 'client'" [formGroup]="clientAttributeForm" class="client-form-in-drawer-ij">
          <div class="client-form-in-drawer">
            <mat-form-field appearance="outline">
              <mat-label>Cliente</mat-label>
              <mat-select formControlName="client_id" required>

                <mat-option *ngFor="let clientItem of (clientList$ | async)?.data" [value]="clientItem.client_id">
                  {{ clientItem.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>SKU (para cliente)</mat-label>
              <input matInput formControlName="sku">
            </mat-form-field>

          </div>
          <mat-form-field appearance="outline">
            <mat-label>Nombre (para cliente)</mat-label>
            <input matInput formControlName="name" [disabled]="true">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Label (para cliente)</mat-label>
            <input matInput formControlName="label">
          </mat-form-field>


        </form>

        <ng-container *ngFor="let filter of filters">
          <div class="menu-item-checkbox">
            <mat-checkbox class="check" color="primary" [checked]="filter.checked"
              (change)="onCheckboxChange(filter, $event.checked)">
            </mat-checkbox>

            <mat-form-field appearance="outline" class="sub-filter-select">
              <mat-label>{{ filter.displayName }}</mat-label>
              <mat-select [disabled]="!filter.checked" [value]="filter.selectedValue"
                (selectionChange)="onSelectionChange(filter, $event.value)">

                <mat-select-trigger>
                  {{ getSelectedOptionName(filter) }}
                </mat-select-trigger>

                <mat-option>
                  <ngx-mat-select-search [formControl]="filter.searchControl" placeholderLabel="Buscar..."
                    noEntriesFoundLabel="No se encontraron resultados">
                  </ngx-mat-select-search>
                </mat-option>

                <mat-option *ngFor="let option of filter.filteredOptions" [value]="option.id">
                  {{ option.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>

      </div>




    </div>
  </mat-drawer>

  <app-main-header [name_main]="titleHeader" [id_code]="libraryId" [goBack]="true">
    <mat-slide-toggle class="active-toggle" [formControl]="activeControl" color="primary">
      {{ activeControl.value ? 'Activo' : 'Inactivo' }}
    </mat-slide-toggle>
    <button *ngIf="libraryId" mat-flat-button color="primary"
      [disabled]="!libraryForm.valid || (libraryForm.pristine && !fileToUpload)"
      (click)="updateObject()">ACTUALIZAR</button>
    <button *ngIf="!libraryId" mat-flat-button color="primary" [disabled]="!libraryForm.valid"
      (click)="createObject()">GUARDAR</button>
  </app-main-header>

  <ng-container *ngIf="libraryObjectData$ | async as data">
    <ng-container *ngIf="data">
      <div *ngIf="isLoading" class="loading-indicator">
        <p>Cargando datos del producto...</p>
      </div>

      <div *ngIf="!isLoading">
        <div class="page-wrapper">
          <div class="form-layout">
            <mat-card class="thumbnail-card" (click)="fileInput.click()">
              <img [src]="thumbnailPreview || data.thumbnail" alt="Vista previa"
                *ngIf="thumbnailPreview || data.thumbnail; else noImage" />
              <ng-template #noImage>
                <img style="width: 50px; height: auto; margin-bottom: 10px;" src="assets/icons/no_image.svg"
                  alt="Sin imagen">
                <span>Producto sin imagen</span>
              </ng-template>
              <input #fileInput type="file" accept="image/*" (change)="onImageChange($event)" hidden>
            </mat-card>

            <form [formGroup]="libraryForm" class="form1">

              <div class="library-data">

                  <ng-container *ngFor="let field of formConfig">
                    <mat-form-field appearance="outline" class="set-space">
                      <mat-label>{{ field.label }}</mat-label>
                      <input matInput [formControlName]="field.controlName" type="text">
                    </mat-form-field>
                    <div
                      *ngIf="libraryForm.get(field.controlName)?.hasError('minlength') && libraryForm.get(field.controlName)?.touched"
                      class="alert-danger">
                      <small>Debe tener al menos 3 caracteres.</small>
                    </div>
                    <div
                      *ngIf="libraryForm.get(field.controlName)?.hasError('maxlength') && libraryForm.get(field.controlName)?.touched"
                      class="alert-danger">
                      <small>No debe exceder los 64 caracteres.</small>
                    </div>
                  </ng-container>

                <mat-form-field appearance="outline" class="set-space" style="height: 56px;">
                  <mat-label>Modelos asociados</mat-label>
                  <mat-select formControlName="models" multiple>
                    <mat-option>
                      <ngx-mat-select-search [formControl]="searchTerm" placeholderLabel="Buscar..."
                        noEntriesFoundLabel="No se encontraron resultados">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let model of (filteredModels$ | async ); trackBy: trackByModelId"
                      [value]="model.model_id">
                      {{ model.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </form>
          </div>
          <div>

            <div class="toolbar" *ngIf="assignedModelNames.length > 0">
              <span class="title-sec">Modelos asociados</span>
              <div class="toolbar-buttons">

              </div>
            </div>

            <div *ngIf="assignedModelNames.length > 0" class="assigned-models-display">
              <mat-chip-listbox aria-label="Modelos asignados">
                <mat-chip *ngFor="let modelName of assignedModelNames">
                  {{ modelName }}
                </mat-chip>
              </mat-chip-listbox>
            </div>
          </div>
          <div class="toolbar">
            <span class="title-sec">Atributos del producto</span>
            <div class="toolbar-buttons">
              <button mat-stroked-button color="primary" (click)="openProductDrawer()"
                [disabled]="disableAddButtons">Añadir</button>
            </div>
          </div>

          <div style="display: flex; gap: 4px; flex-wrap: wrap;"
            *ngIf="data.library_attributes.length > 0; else noAttributes">
            <div class="default-table" *ngFor="let attribute of data.library_attributes">
              <p class="label-attribute">{{ attribute.library_attribute_type.label }}</p>
              <p class="value-attribute">{{ attribute.name }}</p>
            </div>
          </div>
          <ng-template #noAttributes>
            <div class="empty-state">
              <mat-icon>diamond</mat-icon>
              <p>No hay atributos para el producto</p>
            </div>
          </ng-template>
        </div>

        <div class="page-wrapper">
          <div class="toolbar">
            <span class="title-sec">Atributos por cliente</span>
            <div class="toolbar-buttons">
              <button mat-stroked-button color="primary" (click)="openClientDrawer()"
                [disabled]="disableAddButtons">Añadir</button>
            </div>
          </div>

          <div *ngIf="clientAttributes && clientAttributes.length > 0; else noAttributesClient"
            class="client-attributes-section">
            <mat-accordion>
              <mat-expansion-panel *ngFor="let clientAttribute of clientAttributes; let i = index" [expanded]="i === 0">
                <mat-expansion-panel-header>
                  <div class="pane-header">
                    <div [ngSwitch]="clientAttribute.client_id" style="display: flex;">
                      <img width="40" *ngSwitchCase="2" src="assets/logo-postb.svg" alt="Logo Postobon">
                      <img width="40" *ngSwitchCase="5" src="assets/logo-alpina.svg" alt="Logo Alpina">
                      <img width="40" *ngSwitchCase="4" src="assets/logo-lucro.svg" alt="Logo Lucro">
                      <img width="40" *ngSwitchCase="6" src="assets/logo-ramo.png" alt="Logo Ramo">
                      <img width="40" *ngSwitchCase="7" src="assets/logo-bepe.svg" alt="Logo Bepensa">
                      <img width="40" *ngSwitchCase="37" src="assets/logo-bepe.svg" alt="Logo Bepensa">
                      <img width="80" *ngSwitchCase="137" src="assets/biv.png" alt="Logo Bivien">
                      <span style="opacity: 0.5; margin-left: 10px;" *ngIf="clientAttribute.sku">
                        SKU: {{ clientAttribute.sku }}</span>
                    </div>
                    <div class="panel-actions">
                      <button mat-icon-button color="primary" aria-label="Editar atributos del cliente"
                        (click)="openEditClientDrawer(clientAttribute); $event.stopPropagation()">
                        <mat-icon>edit_arrow_down</mat-icon>
                      </button>
                    </div>
                  </div>
                </mat-expansion-panel-header>
                <div style="display: flex; gap: 4px; flex-wrap: wrap;">
                  <div *ngFor="let attribute of clientAttribute.library_attributes" class="default-table">
                    <p class="attribute-label"><b>{{ attribute.library_attribute_type.label }}</b></p>
                    <p class="attribute-value">{{ attribute.name }}</p>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <ng-template #noAttributesClient>
            <div class="empty-state">
              <mat-icon>badge</mat-icon>
              <p>Este producto no tiene atributos definidos por cliente.</p>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </ng-container>
</mat-drawer-container>